/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './verifyPhone.defs.js'
export * as $defs from './verifyPhone.defs.js'
